import React from 'react';
import { Play } from 'lucide-react';

const reels = [
    {
        hook: 'FIRE YOUR CUSTOMER SUPPORT TEAM, USE THIS',
        date: 'Mar 19',
        gradient: 'from-cyan-600 via-sky-500 to-blue-400',
        url: 'https://www.instagram.com/reel/DWEPAwNAbDF/?igsh=OGVyOGJtcjg1cmxp',
        emoji: '🤖',
    },
    {
        hook: 'AI IS QUIETLY CHANGING BETTING PLATFORMS',
        date: 'Mar 23',
        gradient: 'from-violet-600 via-purple-500 to-fuchsia-400',
        url: 'https://www.instagram.com/reel/DWOi3ZFgbVg/?igsh=bHAwanBjcXR4OXI2',
        emoji: '🎰',
    },
    {
        hook: 'PREDICTION MARKETS HIT $1.3B',
        date: 'Apr 12',
        gradient: 'from-emerald-600 via-teal-500 to-cyan-400',
        url: 'https://www.instagram.com/p/DXCLVMwgSbY/?igsh=MXh1bG5xaHdidXljeA==',
        emoji: '📈',
    },
    {
        hook: 'PEOPLE ARE NOW BETTING',
        date: 'Apr 17',
        gradient: 'from-amber-600 via-orange-500 to-red-400',
        url: 'https://www.instagram.com/reel/DXQr-DAhFMD/?igsh=NXhpb2hmbHVoenRo',
        emoji: '🎲',
    },
    {
        hook: 'WHILE YOUR COMPETITORS',
        date: 'Apr 24',
        gradient: 'from-indigo-600 via-blue-500 to-cyan-500',
        url: 'https://www.instagram.com/reel/DXhPGsOBPOG/?igsh=dmkyYndzNmNydnQw',
        emoji: '⚡',
    },
];

export const TopReels = () => {
    return (
        <section className="py-16 px-4">
            <div className="container mx-auto max-w-6xl">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-center">
                    Highlight Reels (Mar – Apr)
                </h2>
                <p className="text-white/50 text-center mb-10 max-w-xl mx-auto">
                    The strongest-performing reels from this period. Tap any card to watch.
                </p>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
                    {reels.map((reel, i) => (
                        <a
                            key={i}
                            href={reel.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group relative block rounded-[2rem] overflow-hidden transition-transform duration-300 hover:scale-[1.03]"
                            style={{ aspectRatio: '9/16' }}
                        >
                            <div className={`absolute inset-0 bg-gradient-to-br ${reel.gradient}`} />

                            <div className="absolute inset-0 flex flex-col items-center justify-center">
                                <span className="text-5xl mb-3 opacity-30 group-hover:opacity-0 transition-opacity duration-300">{reel.emoji}</span>
                            </div>

                            <div className="absolute top-1/3 left-3 right-3">
                                <div className="bg-black/60 backdrop-blur-sm rounded-xl px-3 py-2 border border-white/10">
                                    <p className="text-white text-xs sm:text-sm font-bold leading-tight text-center">{reel.hook}</p>
                                </div>
                            </div>

                            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 backdrop-blur-0 group-hover:backdrop-blur-sm transition-all duration-300 flex items-center justify-center">
                                <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-75 group-hover:scale-100">
                                    <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-md border border-white/30 flex items-center justify-center">
                                        <Play size={24} className="text-white ml-1" fill="white" />
                                    </div>
                                </div>
                            </div>

                            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/70 to-transparent">
                                <p className="text-white/70 text-xs font-mono">{reel.date}</p>
                            </div>

                            <div className="absolute top-3 left-3">
                                <span className="bg-black/40 backdrop-blur-md text-white text-xs font-bold px-2.5 py-1 rounded-full border border-white/10">
                                    #{i + 1}
                                </span>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};
